module.exports = __webpack_public_path__ + "static/media/view-usage-tutorial-1.34e9c15b.gif";